import { render, staticRenderFns } from "./serial-profile.vue?vue&type=template&id=2d498d5a&scoped=true&"
import script from "./serial-profile.vue?vue&type=script&lang=js&"
export * from "./serial-profile.vue?vue&type=script&lang=js&"
import style0 from "./serial-profile.vue?vue&type=style&index=0&id=2d498d5a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d498d5a",
  null
  
)

export default component.exports